<template>
  <div>
    <swiper-container v-if="posts.length > 0" :options="swiperOptions">
      <swiper-slide v-for="post in posts" :key="post.file">
        <router-link :to="{ name: 'VxPost', params: { id: post.file } }">
          {{ post.title }}
        </router-link>
      </swiper-slide>
    </swiper-container>
    <div v-else>
      <p>No hay posts disponibles.</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import {  SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';

export default {
  name: 'VxBlog',
  components: {
    
    SwiperSlide
  },
  setup() {
    const posts = ref([]);
    const swiperOptions = ref({
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        clickable: true
      },
      navigation: true
    });

    onMounted(async () => {
      try {
        const response = await fetch('/post/posts.json');
        if (!response.ok) {
          throw new Error('No se pudo cargar el archivo de posts');
        }
        const data = await response.json();
        posts.value = data.map(post => ({
          title: post.title,
          file: post.file
        }));
      } catch (error) {
        console.error('Error:', error);
      }
    });

    return {
      posts,
      swiperOptions
    };
  }
};
</script>

<style scoped>
/* Estilos para el Swiper */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.swiper-slide a {
  text-decoration: none;
  color: var(--color-primary); /* Ajusta el color del enlace según tu diseño */
  font-size: 1.2rem;
}

p {
  color: red;
}
</style>
